<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Reporte de Ítems</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button @click="exportar" type="button" class="btn-success btn--bigger">
            <i class="fa fa-file-excel-o"></i>
            <span>Exportar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-3">
            <div class="form-field select">
              <div class="select-field select-field--stretch">
                <select name="tipo_item" id="tipo_item" v-model="form.tipo_item">
                  <option value="T">Todos</option>
                  <option value="P">Productos</option>
                  <option value="S">Servicios</option>
                </select>
                <label for="tipo_item">Tipo</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div class="form-field select2 select2-field--stretch">
              <div class="select2-field">
                <v-select
                  placeholder="Seleccione..."
                  id="categoria"
                  @input="inputCategoria"
                  v-model="selectedCategoria"
                  :options="categorias"
                  label="nombre"
                ></v-select>
                <label for="categoria">Categoría</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div class="form-field select2 select2-field--stretch">
              <div class="select2-field">
                <v-select
                  placeholder="Seleccione..."
                  id="marca"
                  @input="inputMarca"
                  v-model="selectedMarca"
                  :options="marcas"
                  label="nombre"
                ></v-select>
                <label for="marca">Marca</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div class="form-field select">
              <div class="select-field select-field--stretch">
                <select name="tipo" id="tipo" v-model="form.tipo">
                  <option value="E">Ventas</option>
                  <option value="P">Compras</option>
                </select>
                <label for="tipo">Disponibilidad</label>
              </div>
            </div>
          </div>
        </div>
        <k-table
          :params="form"
          :filterStatus="false"
          :createButton="false"
          :editButton="false"
          :deleteButton="false"
          ref="listaItems"
          :path="url + '/items/reportes'"
          :columns="[
                    {
                        display : 'Código',
                        value : 'codigo'
                    },
                    {
                        display : 'Tipo',
                        value : 'descripcion_tipo_item'
                    },
                    {
                        display : 'Categoría',
                        value : 'descripcion_categoria'
                    },
                    {
                        display : 'Nombre',
                        value : 'nombre'
                    },
                    {
                        display : 'Descripción',
                        value : 'descripcion'
                    },
                    {
                        display : 'Marca',
                        value : 'descripcion_marca'
                    },
                    {
                        display : 'Precio de venta',
                        value : 'precio_venta'
                    },
                    {
                        display : 'Subsidio',
                        value : 'valor_subsidio'
                    },
                    {
                        display : 'IVA',
                        value : 'iva'
                    },
                    {
                        display : 'ICE',
                        value : 'ice'
                    },
                    {
                        display : 'IRBPNR',
                        value : 'descripcion_irbpnr'
                    }
                ]"
        ></k-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    marcas: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    categorias: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      form: {
        marca_id: "",
        categoria_id: "",
        tipo_item: "T",
        tipo: "E"
      },
      errores: {},
      selectedCategoria: null,
      selectedMarca: null,
      url: url
    };
  },
  methods: {
    inputMarca: function() {
      if (this.selectedMarca !== null)
        this.form.marca_id = this.selectedMarca.id;
      else this.form.marca_id = "";
    },
    inputCategoria: function() {
      if (this.selectedCategoria !== null)
        this.form.categoria_id = this.selectedCategoria.id;
      else this.form.categoria_id = "";
    },
    consultar: function() {
      this.$refs.listaItems.loadRows();
    },
    exportar: function() {
      window.open(
        url +
          "/items/reportes?exportar=S&categoria_id=" +
          this.form.categoria_id +
          "&marca_id=" +
          this.form.marca_id +
          "&tipo=" +
          this.form.tipo +
          "&tipo_item=" +
          this.form.tipo_item +
          "&search=" +
          this.$refs.listaItems.form.search,
        "_blank"
      );
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/reportes/ReporteItems.vue